import SlideInWrapper from 'components/SlideInWrapper'
import AppsIntegration from 'components/integrations/apps/AppsIntegration'
import useSectionOpenedTracking from 'hooks/useSectionOpenedTracking'

function Apps() {
	useSectionOpenedTracking()

	return (
		<SlideInWrapper>
			<AppsIntegration />
		</SlideInWrapper>
	)
}

export default Apps
